module.exports = __webpack_public_path__ + "static/img/head-en.953c95a2.webp";